import { ActivityItemTypeFilterOption } from '../../graphql/schema';

export const ACTIVITY_TYPE_LABELS: Record<ActivityItemTypeFilterOption, string> = {
  [ActivityItemTypeFilterOption.AllocationChange]: 'Portfolio Changes',
  [ActivityItemTypeFilterOption.Deposit]: 'Deposits',
  [ActivityItemTypeFilterOption.DividendPayment]: 'Dividends',
  [ActivityItemTypeFilterOption.Fees]: 'Fees',
  [ActivityItemTypeFilterOption.InterestPayment]: 'Interest',
  [ActivityItemTypeFilterOption.Other]: 'Other',
  [ActivityItemTypeFilterOption.Rebalance]: 'Rebalances',
  [ActivityItemTypeFilterOption.TaxLossHarvest]: 'Tax-loss Harvesting',
  [ActivityItemTypeFilterOption.Trade]: 'Trading',
  [ActivityItemTypeFilterOption.Transfer]: 'Transfers',
  [ActivityItemTypeFilterOption.Withdrawal]: 'Withdrawals',
};
